export default __webpack_public_path__ + "static/media/carta_compromisso.0ec94127.png";